import { takeUntil } from 'rxjs/operators';
import { Component } from '@angular/core'

import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'

import * as fromCatalog from '../../reducers'
import * as fromBase from '../../../base/reducers'
import { ContainerBase } from '../../../core/base/container-base';
import { Product } from '../../../core/models/product';
import { Crumb } from '../../../core/models/crumb';
import { PageRoutingService } from '../../../core/services/page-routing.service';

@Component({
  selector: 'app-product-page-container',
  templateUrl: './product-page-container.html'
})
export class ProductPageContainer extends ContainerBase {
  product$: Observable<Product>
  showCrumbs: boolean;
  crumbs$: Observable<Crumb[]>;
  
  constructor(
    private store: Store<fromCatalog.State>,
    private pageRouting: PageRoutingService,
  ) {
    super()

    this.product$ = store
    .pipe(
    select(fromCatalog.getSelectedProduct),
    takeUntil(this.destroyed$)
    )

    // get show breadcrumbs
    this.store.pipe(select(fromBase.getTenantSettings), takeUntil(this.destroyed$)).subscribe(settings => {
        this.showCrumbs = settings.show_breadcrumbs
      } 
    )

    // get crumbs
    this.crumbs$ = this.pageRouting.breadCrumbs$

    
  }
}